export const IThemeRepositoryType = Symbol('IThemeRepository');
